const beehiveDetails = {
  tabs: {
    info: 'Information',
    iot: 'IoT data'
  }
}

export default beehiveDetails
